import React, { useState } from 'react'
import { InfoCircle } from 'react-bootstrap-icons'

export default function InfoTooltip({ text }) {
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <span
      className="relative inline-block normal-case font-normal text-rb-green dark:text-rb-green cursor-help"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <InfoCircle />
      {showTooltip && (
        <div
          style={{ width: 260 }}
          className="absolute top-full left-1/2 -translate-x-1/2 mt-1 z-10 bg-rb-light-green dark:bg-rb-dark-mode-lighter text-rb-black dark:text-white p-2 rounded-md border-1 border-rb-green text-sm font-normal"
        >
          {text}
        </div>
      )}
    </span>
  )
}
